import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-store-management',
  templateUrl: './store-management.component.html',
  styleUrls: ['./store-management.component.css']
})
export class StoreManagementComponent implements OnInit {

  address1: string;
  address2: string;
  city: string;
  state: string;
  constructor() { }
  ngOnInit() {
  }

}
